import styled from "styled-components";

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
`;

export const Row = styled.div`
  background: rgba(239, 239, 239, 0.8);
  -webkit-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  -moz-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  border-radius: 1.5%;
  display: flex;
  align-items: center;
  flex-direction: row;

    .container {
        margin: 50px;
    }
`;

export const Field = styled.span`
  color: #222;
  width: 100%;
  text-align: left;
  font-size: 1em;
  max-width: 650px;
  word-wrap: break-word !important;
`;

export const Align = styled.div`
    width: 100%;
    display: flex;
`;
